export default __webpack_public_path__ + "static/media/search.44b2e91d.svg";